import axios from 'axios';
import { addresses, authorization, baseUrl } from './api-config';

const defaultOptions = {
  baseURL: baseUrl.apiConvenio.PROD,
  credentials: authorization.credentials,
  headers: authorization.headers
};

const defaultOptionsAccess = {
  baseURL: baseUrl.apiAcesso,
  headers: authorization.headersWithoutToken
};

export const api = { 
  http: axios.create(defaultOptions),
  httpAccess: axios.create(defaultOptionsAccess),
  addresses: addresses
}

api.http.interceptors.request.use((config) => { 
  const token = sessionStorage.getItem('token'); 
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});
